import React from 'react';
import { FormattedNumber } from 'react-intl';

const baseStrReducer = (acc, line) => {
  const matches = line.match(/^\s*(\d+)\.?\s*(.*?)\s*$/);

  if (!matches) return acc;

  return Object.assign({}, acc, { [matches[1]]: matches[2] });
};

const countryStrReducer = (acc, line = '') => {
  const [key, value] = line.split('\t');

  if (!value) return acc;

  return Object.assign({}, acc, { [key]: value.trim() });
};

const listParser = (localizedString = '', reducer) => localizedString.split('\n').reduce(reducer, {});

export const formatOldFilters = (formatMessage) => (facet, value) => {
  switch (facet) {
    case 'benefits':
    case 'atmosphere':
    case 'perks':
      return formatMessage({ id: `JOBS_SEARCH_KUNUNU_BENEFITS_${value.toUpperCase()}` });
    case 'level':
      return listParser(formatMessage({ id: 'JOBLEVEL_LIST' }), baseStrReducer)[value];
    case 'type':
      return formatMessage({ id: `MP_000_RESOURCE_JOB_TYPES_${value.toUpperCase()}` });
    case 'industry':
      return formatMessage({ id: `INDUSTRY_${value.toUpperCase()}` });
    case 'student': {
      const TYPES = ['THESIS', 'INTERNSHIP', 'PARTTIME'];
      return formatMessage({ id: `JOB_STUDENT_CREATE_TYPE_${TYPES[value - 1]}` });
    }
    case 'segments':
      return formatMessage({ id: `XJM_VAMP_${value.toUpperCase()}_FILTER` });
    case 'discipline':
      return listParser(formatMessage({ id: 'UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST' }), baseStrReducer)[value];
    case 'country':
      return listParser(
        formatMessage({ id: 'COUNTRY_LIST' }) + formatMessage({ id: 'COUNTRY_LIST_EXTENDED' }),
        countryStrReducer
      )[value];
    default:
      return value.toString().toUpperCase() + '[RES]';
  }
};

export const FormattedCurrency = (props) => <FormattedNumber style="currency" minimumFractionDigits={0} {...props} />;
